<template>
  <div class="ui bottom fixed massive menu">
    <div class="icon item" @click="toggleFullscreen">
      <i class="maximize icon"></i>
    </div>
    <div class="item" @click="changeBgColor">Kleur {{ game.bgColor + 1 }}</div>
    <transition name="fade" mode="out-in" :appear="true">
      <div
        class="item"
        @click="toggleEditScoresScreen"
        v-if="!$store.getters.clockIsRunning"
      >
        Score
      </div>
    </transition>
    <div
      class="item round-nav"
      @click.stop="previousRound"
      :data-to-round-id="$store.state.game.currentRound - 1"
      v-if="$store.state.game.currentRound > 0"
    >
      <i class="arrow left icon"></i>
    </div>
    <div
      class="item round-nav"
      @click.stop="resetRound"
      :data-round-id="$store.state.game.currentRound"
      v-if="!$store.getters.showRoundIntro"
    >
      <i class="refresh icon"></i>
    </div>
    <div
      class="item round-nav"
      @click.stop="nextRound"
      :data-to-round-id="$store.state.game.currentRound + 1"
      v-if="$store.state.game.currentRound < 5"
    >
      <i class="arrow right icon"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import alertify from 'alertify.js';

export default {
  name: 'host-menu',
  computed: {
    ...mapState(['isFullscreen', 'game']),
    ...mapGetters(['isPremium'])
  },
  methods: {
    ...mapActions(['toggleFullscreen']),
    resetRound() {
      if (this.isPremium) {
        this.$store.dispatch('resetRound');
        this.$store.dispatch('syncGame');
      } else {
        alertify.log(
          'Rondes herstarten niet mogelijk in de gratis basisversie.'
        );
      }
    },
    nextRound() {
      if (this.isPremium) {
        this.$store.dispatch('nextRound');
        this.$store.dispatch('syncGame');
      } else {
        alertify.log(
          'Rondes doorspoelen niet mogelijk in de gratis basisversie.'
        );
      }
    },
    previousRound() {
      if (this.isPremium) {
        this.$store.dispatch('previousRound');
        this.$store.dispatch('syncGame');
      } else {
        alertify.log(
          'Rondes terugkeren niet mogelijk in de gratis basisversie.'
        );
      }
    },
    toggleEditScoresScreen() {
      if (this.isPremium) {
        this.$store.commit('TOGGLE_EDIT_SCORES_SCREEN');
      } else {
        alertify.error(
          'Scores aanpassen niet mogelijk in de gratis basisversie.'
        );
      }
    },
    changeBgColor() {
      if (this.isPremium) {
        this.$store.dispatch('changeBgColor');
        this.$store.dispatch('syncGame');
      } else {
        alertify.error('Niet mogelijk in de gratis basisversie! :-).');
      }
    }
  }
};
</script>

<style scoped>
.item:hover,
.link.item:hover,
a.icon.item:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #f67b3b;
}
.item {
  cursor: pointer;
}
</style>
